import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13f4f6cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-80 h-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<br data-v-13f4f6cf><br data-v-13f4f6cf><div class=\"newsTableDiv0 w-80\" data-v-13f4f6cf><table id=\"tblNews\" data-v-13f4f6cf><thead data-v-13f4f6cf><tr data-v-13f4f6cf><th style=\"width:30%;\" data-v-13f4f6cf>Subject</th><th style=\"width:15%;\" data-v-13f4f6cf>Start Date</th><th style=\"width:15%;\" data-v-13f4f6cf>Last Date</th><th style=\"width:10%;\" data-v-13f4f6cf>Edit</th><th style=\"width:10%;\" data-v-13f4f6cf>Delete</th></tr></thead></table></div>", 3)
const _hoisted_6 = {
  key: 1,
  style: {"height":"calc(97% - 250px)"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "No data", -1 /* HOISTED */))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  id: "divNewsTable",
  class: "newsTableDiv0 w-80",
  style: {"overflow":"auto","height":"calc(97% - 250px)","margin-top":"0%"}
}
const _hoisted_10 = {
  id: "tblNews",
  class: "w-80"
}
const _hoisted_11 = { id: "tblNewsBody" }
const _hoisted_12 = { style: {"width":"30%"} }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { style: {"width":"15%"} }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { style: {"width":"15%"} }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { style: {"width":"10%"} }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { style: {"width":"10%"} }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  class: "modal fade",
  id: "newsModal",
  tabindex: "-1",
  "aria-labelledby": "newsModalLabel",
  "aria-hidden": "true"
}
const _hoisted_23 = {
  class: "modal-dialog modal-lg modal-dialog-scrollable",
  role: "document",
  style: {"height":"700px"}
}
const _hoisted_24 = { class: "modal-content" }
const _hoisted_25 = { class: "modal-header" }
const _hoisted_26 = {
  class: "modal-title",
  id: "newsModalLabel"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */))
const _hoisted_28 = { class: "modal-body" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "subject",
  class: "adjusting-position fs-6"
}, "Subject", -1 /* HOISTED */))
const _hoisted_31 = {
  class: "adjusting-position fs-6",
  style: {"text-align":"left","color":"red"}
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "content",
  class: "adjusting-position fs-6"
}, "Content", -1 /* HOISTED */))
const _hoisted_35 = {
  class: "adjusting-position fs-6",
  style: {"text-align":"left","color":"red"}
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "startdate",
  class: "adjusting-position fs-6"
}, "Start Date", -1 /* HOISTED */))
const _hoisted_39 = {
  class: "adjusting-position fs-6",
  style: {"text-align":"left","color":"red"}
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "lastdate",
  class: "adjusting-position fs-6"
}, "Last Date", -1 /* HOISTED */))
const _hoisted_43 = {
  class: "adjusting-position fs-6",
  style: {"text-align":"left","color":"red"}
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "importance",
  class: "adjusting-position fs-6"
}, "Importance", -1 /* HOISTED */))
const _hoisted_47 = ["value", "selected"]
const _hoisted_48 = {
  class: "adjusting-position fs-6",
  style: {"text-align":"left","color":"red"}
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_50 = {
  key: 0,
  class: "adjusting-position"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "lastdate",
  class: "adjusting-position fs-6"
}, "Send this news by e-mail", -1 /* HOISTED */))
const _hoisted_52 = ["value"]
const _hoisted_53 = { class: "modal-footer" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal",
  id: "cancel"
}, " Cancel ", -1 /* HOISTED */))
const _hoisted_55 = {
  class: "modal fade",
  id: "deleteModal",
  tabindex: "-1",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true"
}
const _hoisted_56 = { class: "modal-dialog" }
const _hoisted_57 = {
  class: "modal-content",
  style: {"height":"40%"}
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "deleteModalLabel"
  }, "Delete news"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1 /* HOISTED */))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "modal-body",
  style: {"flex":"0 0 auto"}
}, [
  /*#__PURE__*/_createElementVNode("div", null, "Are you sure to delete this news?")
], -1 /* HOISTED */))
const _hoisted_60 = { class: "modal-footer" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal",
  id: "deleteCancel"
}, " Cancel ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isLoading)
      ? (_openBlock(), _createBlock($setup["Loading"], {
          key: 0,
          isLoading: $setup.isLoading
        }, null, 8 /* PROPS */, ["isLoading"]))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["Alert"], {
      "alert-message": $setup.alertMessage,
      "alert-state": $setup.alertState
    }, null, 8 /* PROPS */, ["alert-message", "alert-state"]),
    _createVNode($setup["AdminNavigation"], { menuTile: $setup.menuTitle }, null, 8 /* PROPS */, ["menuTile"]),
    _hoisted_2,
    _createElementVNode("button", {
      class: "btn btn-primary add text-center",
      "data-bs-toggle": "modal",
      "data-bs-target": "#newsModal",
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onClickAddButton()))
    }, " Add news "),
    _hoisted_3,
    ($setup.newsList.length == 0 && $setup.isNoData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _createElementVNode("tbody", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.newsList, (info, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  style: _normalizeStyle({ color: info.importance.color })
                }, [
                  _createElementVNode("td", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(info.Subject), 1 /* TEXT */)
                  ]),
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(info.startDate), 1 /* TEXT */)
                  ]),
                  _createElementVNode("td", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(info.lastDate), 1 /* TEXT */)
                  ]),
                  _createElementVNode("td", _hoisted_18, [
                    _createElementVNode("button", {
                      class: "btn btn-primary button-design-newEdit",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#newsModal",
                      onClick: ($event: any) => ($setup.onClickEditButton(info.id))
                    }, " Edit ", 8 /* PROPS */, _hoisted_19)
                  ]),
                  _createElementVNode("td", _hoisted_20, [
                    _createElementVNode("button", {
                      class: "btn btn-primary button-design-newEdit",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#deleteModal",
                      onClick: ($event: any) => ($setup.getDeleteId(info.id))
                    }, " Delete ", 8 /* PROPS */, _hoisted_21)
                  ])
                ], 4 /* STYLE */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ])),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("h5", _hoisted_26, _toDisplayString($setup.modalTitle), 1 /* TEXT */),
            _hoisted_27
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "subject",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.subject) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.subject]
              ]),
              _createElementVNode("span", _hoisted_31, _toDisplayString($setup.subjectError), 1 /* TEXT */)
            ]),
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _withDirectives(_createElementVNode("textarea", {
                type: "text",
                class: "form-control",
                id: "content",
                rows: "3",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.content) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.content]
              ]),
              _createElementVNode("span", _hoisted_35, _toDisplayString($setup.contentError), 1 /* TEXT */)
            ]),
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _withDirectives(_createElementVNode("input", {
                type: "date",
                onkeydown: "return false",
                class: "form-control",
                id: "startdate",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.startdate) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.startdate]
              ]),
              _createElementVNode("span", _hoisted_39, _toDisplayString($setup.startDateError), 1 /* TEXT */)
            ]),
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _withDirectives(_createElementVNode("input", {
                type: "date",
                onkeydown: "return false",
                class: "form-control",
                id: "lastdate",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.lastdate) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.lastdate]
              ]),
              _createElementVNode("span", _hoisted_43, _toDisplayString($setup.endDateError), 1 /* TEXT */)
            ]),
            _hoisted_44,
            _createElementVNode("div", _hoisted_45, [
              _hoisted_46,
              _withDirectives(_createElementVNode("select", {
                class: "adjusting-position form-select input-item-news-faq",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.selectedImportance) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.importanceList, (info, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    class: "adjusting-option",
                    key: index,
                    value: info['importance_id'],
                    selected: _ctx.option == 'selectedImportance'
                  }, _toDisplayString(info["importance"]) + " (" + _toDisplayString(info["color"]) + ") ", 9 /* TEXT, PROPS */, _hoisted_47))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, $setup.selectedImportance]
              ]),
              _createElementVNode("span", _hoisted_48, _toDisplayString($setup.importanceError), 1 /* TEXT */)
            ]),
            _hoisted_49,
            ($setup.store.getters.mainMenuCode != 'MM0069')
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _hoisted_51,
                  _createElementVNode("input", {
                    type: "checkbox",
                    onChange: _cache[6] || (_cache[6] = ($event: any) => ($setup.chkSendEmailChkChange($event))),
                    value: $setup.isSendEmail,
                    class: "ml-10",
                    id: "chkSendNewsEmail"
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_52)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_53, [
            _hoisted_54,
            ($setup.buttonName == 'Add')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary add footer-btn",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.AddOrUpdateNews()))
                }, _toDisplayString($setup.buttonName), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            ($setup.buttonName == 'Update')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn btn-primary footer-btn",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.AddOrUpdateNews()))
                }, _toDisplayString($setup.buttonName), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_55, [
      _createElementVNode("div", _hoisted_56, [
        _createElementVNode("div", _hoisted_57, [
          _hoisted_58,
          _hoisted_59,
          _createElementVNode("div", _hoisted_60, [
            _hoisted_61,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary footer-btn",
              onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.deleteNews()))
            }, " Delete ")
          ])
        ])
      ])
    ])
  ]))
}